import { render, staticRenderFns } from "./AcceptContract.vue?vue&type=template&id=64fa963a&scoped=true&"
import script from "./AcceptContract.vue?vue&type=script&lang=js&"
export * from "./AcceptContract.vue?vue&type=script&lang=js&"
import style0 from "./AcceptContract.vue?vue&type=style&index=0&id=64fa963a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fa963a",
  null
  
)

export default component.exports